import useSession from './useSession';

const SUPPORTER_ROLE_ID = 10;

export default function useAdFree() {
    const session = useSession();

    if (window.adFree) return true;
    if (session.loadStatus === 'pending') return true;

    return session.user?.Roles.some((role) => role.ID === SUPPORTER_ROLE_ID) ?? false;
}
